var config = {
    base_url : "http://api.rls.danjiguanjia.com",//正式
    // base_url : "https://api.dev.danjiguanjia.com",//测试
    base2_url : "http://api.danjiguanjia.com",
    base3_url : "http://breed.danjiguanjia.com",//正式
    // base3_url : "http://breed.test.jianong.com"//测试


    // base3_url : 'http://wk.jianong.com.cn',
}

export default config


// WEBPACK FOOTER //
// ./src/api/config.js